// START_MODULE components_organisms_footer_footer_tsx
// START_CONTRACT
// PURPOSE: Preserve this module from the original Tomsk Data Science frontend.
// OPERATIONAL_CONTEXT: Imported by the public static React application.
// CONTRACT: Keep the established layout, styling, and component behavior intact.
// KEYWORDS: legacy-frontend, static-site, tomsk-data-science
// COMPLEXITY: 2
// END_CONTRACT
import React from 'react';
import styled from 'styled-components';

const currentYear = new Date().getFullYear();

const Footer: React.FC = () => (
  <>
    <FooterWrapper>
      <svg
        viewBox="0 0 500 150"
        preserveAspectRatio="none"
        style={{
          height: '100%', width: '100%', position: 'absolute', top: 0, left: 0, zIndex: '-1',
        }}
      >
        <path
          d="M-142.49,-68.56 C99.60,262.02 270.59,-129.75 734.47,211.69 L606.94,315.30 L0.00,150.00 Z"
          style={{ stroke: 'none', fill: '#4b4b4b' }}
        />
      </svg>
      <p>{`©${currentYear} All rights reserved`}</p>
      <p>Tomsk Data Science</p>
    </FooterWrapper>
  </>
);

const FooterWrapper = styled.div`
  position: relative;
  padding: 0 88px 36px 88px;
  height: 200px;

  color: white;

  display: flex;
  justify-content: space-between;
  align-items: end;

  margin-top: -80px;

  z-index: -1;
`;

export default Footer;

// END_MODULE components_organisms_footer_footer_tsx
